import * as z from "zod/v4";
import { EbayListingSchema_ } from "./ebay-listing";
import { PoshmarkListingSchema_ } from "./poshmark-listing";
import { RedoListingSchema_ } from "./redo-listing";
import { ShopifyListingSchema_ } from "./shopify/shopify-listing";

const ListingDetailSchema_ = z.discriminatedUnion("channel", [
  ShopifyListingSchema_,
  EbayListingSchema_,
  PoshmarkListingSchema_,
  RedoListingSchema_,
]);
export const ListingDetailSchema: z.ZodType<ListingDetail> =
  ListingDetailSchema_;
export type ListingDetail = z.infer<typeof ListingDetailSchema_>;
